<template>
    <div class="envia-hero">
        <img class="envia-hero__banner" alt="Tendencys" :src="getHeroImage()" @error="getHeroImageError" />
    </div>
</template>

<script>
import TrackingModule from '@/components/envia/TrackingModule.vue';

export default {
    name: 'EnviaHero',
    components: {
        TrackingModule,
    },
    methods: {
        getHeroImage() {
            let { lang } = this.$route.query;
            return `${window.ENV.VUE_APP_S3_URL}/images/login/envia/${lang || 'en-US'}.png`;       
        },
        getHeroImageError(event) {
            event.target.src = `${window.ENV.VUE_APP_S3_URL}/images/login/envia/en-US.png`;
        },
    },
};
</script>

<style lang="scss">
.envia-hero {
    align-items: center;
    background: #dae9eb;
    display: flex;
    flex-grow: 1;
    justify-content: center;

    &__banner {
        width: 100%;
        height: 100%;
    }
}

.envia-tracking-module {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
}

.tracking-module {
    margin-top: 30px;

    @media (max-width: 768px) {
        display: none;
        
    }
}
</style>
